import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostEngagingPostsConfig = {
    title: 'chart.linkedin.widget_most_engaging_posts',
    id: 'widget_most_engaging_posts',
    size: SIZE_FULL,
    sortFields: [
        'engagement_rate',
        'created',
        'likes',
        'comments',
        'shares',
        'impressions',
        'clicks',
        'reach'
    ],
    type: 'widget',
    element: MediasWidget
};
